import { render, staticRenderFns } from "./DocVersions.vue?vue&type=template&id=7048d6ef&"
import script from "./DocVersions.vue?vue&type=script&lang=js&"
export * from "./DocVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports